/**
 * @generated SignedSource<<6c5c56565a263858e83879bac6098f37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsTaskDependenciesQuery$variables = {};
export type SettingsTaskDependenciesQuery$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SettingsTaskDependencies_viewer">;
  } | null;
};
export type SettingsTaskDependenciesQuery = {
  variables: SettingsTaskDependenciesQuery$variables;
  response: SettingsTaskDependenciesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "settings_task_dependencies"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"settings_task_dependencies\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsTaskDependenciesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SettingsTaskDependencies_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SettingsTaskDependenciesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cascadeDependencyDates",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d70b73d10d614acfb6d4f92511122562",
    "id": null,
    "metadata": {},
    "name": "SettingsTaskDependenciesQuery",
    "operationKind": "query",
    "text": "query SettingsTaskDependenciesQuery {\n  viewer {\n    actualPersonId\n    component(name: \"settings_task_dependencies\")\n    ...SettingsTaskDependencies_viewer\n    id\n  }\n}\n\nfragment SettingsTaskDependencies_viewer on Viewer {\n  actualPersonId\n  id\n  company {\n    id\n    cascadeDependencyDates\n  }\n}\n"
  }
};
})();

(node as any).hash = "d599e74a0e952e5e598077248ce56445";

export default node;
